export default {"src":"/_next/static/media/google.a0d96b1e.svg","height":120,"width":118,"blurWidth":0,"blurHeight":0};